import { Component, EventEmitter, Input, Output, Optional, Host } from '@angular/core';
import { C4InputInterface, C4Input, C4InputConfig } from '../c4-input';
import { C4Form } from '../c4-form';

@Component({
  selector: 'c4-input-slider-float',
  templateUrl: 'c4-input-slider-float.html',
  styles: [`
		.control-label {
			font-weight: normal;
		}
	`],
})
export class C4InputSliderFloat extends C4Input implements C4InputInterface {
  @Input() config;
  @Input() name: string;
  @Input() tagId: string;
  @Input() value: number;

  @Output() valueChange: EventEmitter<number> = new EventEmitter<number>();

  @Input() precision: number;
  @Input() increment: number;
  @Input() stepCount: number;
  @Input() min: number;
  @Input() max: number;

  constructor( @Optional() @Host() form: C4Form) {
    super(form);
  }

  ngAfterViewInit() {

    let increment: number;

    if (this.increment !== undefined) {
      increment = this.increment;
    } else if (this.stepCount !== undefined) {
      increment = (this.max - this.min) / this.stepCount;
    }
  }
}



// WEBPACK FOOTER //
// ./~/@c4/ui/src/app/directives/input/slider-float/c4-input-slider-float.ts